import { GET } from '../utils/request';
import { API_PREFIX } from '../consts';

export function getFeatureConfig(featureName) {
  return GET(`${API_PREFIX}/v1/config/feature/${featureName}`);
}
